import React from "react";
import c3 from "c3";
import "c3/c3.css";

const Chart = (props) => {
  React.useEffect(() => {
    c3.chart.internal.fn.additionalConfig = {
      bar_radiusAll: false,
      bar_radius: 5,
      tooltip_format_color: undefined,
    };
    c3.generate({
      bindto: `#${props.name}`,
      size: {
        height: 200,
        width: 150,
      },
      data: {
        rows: props.data,
        type: props.type,
      },
      donut: {
        width: 40,
      },
      legend: {
        show: false,
      },
      color: {
        pattern: props.pattern,
      },
      axis: props.axisObj,
      bar: {
        space: 0.3,
      },
    });
  }, [props]);

  return (
    <div id={props.name} />
  );
};

export default Chart;
